export const USER_INITIAL_DATA_SET = 'USER_INITIAL_DATA_SET';
export const USER_INFO_UPDATE = 'USER_UPDATE';
export const USER_CONTACT_UPDATE = 'USER_CONTACT_UPDATE';
export const USER_ABOUT_UPDATE = 'USER_ABOUT_UPDATE';
export const USER_REQUIREMENT_UPDATE = 'USER_REQUIREMENT_UPDATE';
export const USER_ROLE_UPDATE = 'USER_ROLE_UPDATE';
export const USER_STATUS_UPDATE = 'USER_STATUS_UPDATE';
